@if ((e911ShelfPanel | async) === 'view') {
<onsip-admin-e911-table-shelf-view
  [e911Location]="e911Location"
  [userAddressE911Info]="userAddressE911Info"
  (editPanel)="togglePanel('edit')"
>
</onsip-admin-e911-table-shelf-view>
} @if ((e911ShelfPanel | async) === 'edit') {
<onsip-admin-e911-table-shelf-edit
  [e911Location]="e911Location"
  [userAddressE911Info]="userAddressE911Info"
  (viewPanel)="togglePanel('view')"
>
</onsip-admin-e911-table-shelf-edit>
}
